import { combineReducers } from 'redux';

export function error(state = null, action) {
  switch (action.type) {
    case 'ACCOUNT_CREATE_ERROR':
      return action.error;

    case 'ACCOUNT_CREATE_RESET':
      return false;

    default:
      return state;
  }
}

export function loading(state = false, action) {
  switch (action.type) {
    case 'ACCOUNT_CREATE_LOADING':
      return action.loading;

    case 'ACCOUNT_CREATE_RESET':
      return false;

    default:
      return state;
  }
}

export default combineReducers({ error, loading });
